'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
const FOOTER_VISIBLE_ROUTES = ['/batchfinder', '/cancellation', '/terms-and-conditions-i', '/disclaimer', '/refund-policy', '/privacy-policy-i'];
export function Footer() {
  const pathname = usePathname();
  const shouldShowFooter = pathname ? FOOTER_VISIBLE_ROUTES.some(route => pathname.endsWith(route)) : false;
  return <footer className={`${shouldShowFooter ? '' : 'hidden'} w-full bg-[#333333] py-8 text-white md:py-12`} data-sentry-component="Footer" data-sentry-source-file="footer.tsx">
      <div className="mx-auto w-10/12 px-4">
        <section className="border-gray-400">
          <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
            <small className="text-center text-sm text-gray-200 md:text-left">
              Copyright © 2024 ELT global
            </small>
            <nav aria-label="Legal links">
              <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-200">
                <Link href="/privacy-policy-i" className="transition-colors hover:text-gray-200" data-sentry-element="Link" data-sentry-source-file="footer.tsx">
                  Privacy Policy
                </Link>
                <Link href="/terms-and-conditions-i" className="transition-colors hover:text-gray-200" data-sentry-element="Link" data-sentry-source-file="footer.tsx">
                  Terms and Conditions
                </Link>
                <Link href="/disclaimer" className="transition-colors hover:text-gray-200" data-sentry-element="Link" data-sentry-source-file="footer.tsx">
                  Disclaimer
                </Link>
                <Link href="/refund-policy" className="transition-colors hover:text-gray-200" data-sentry-element="Link" data-sentry-source-file="footer.tsx">
                  Refund Policy
                </Link>
                <Link href="/cancellation" className="transition-colors hover:text-gray-200" data-sentry-element="Link" data-sentry-source-file="footer.tsx">
                  Cancellation
                </Link>
              </div>
            </nav>
          </div>
        </section>
      </div>
    </footer>;
}